export const environment = {
  production: true,
  buildId: '3926765461823881',
  configFile: 'config.json',
};
